import { useEffect, useState } from 'react';

import { useMenu } from 'global/MenuContext';
import { MenuItem, isMeetingRoomExtras } from 'types/menuTypes';
import { logger } from 'utils/logger';

export interface MenuRoute {
  documentId: string;
  path: string;
  component: React.ReactNode;
  isMeetingRoom?: boolean;
}

export const useMenuRoutes = () => {
  const { menu } = useMenu();
  const [routes, setRoutes] = useState<MenuRoute[]>([]);

  useEffect(() => {
    const mapMenuToRoutes = (menuItems: MenuItem[]): MenuRoute[] => {
      return menuItems.reduce((acc: MenuRoute[], item: MenuItem) => {
        // Check if it is a meeting room menu
        const isMeetingRoom = item.feature?.dynamic_component === 'MEETING_ROOM';
        const isMeetingRoomRoom = item.feature?.dynamic_component === 'MEETING_ROOM_ROOM';

        // Add the current item's route
        if (item.feature?.documentId || (item.extras && isMeetingRoomExtras(item.extras))) {
          let documentId = item.feature?.documentId || '';

          // If it's a meeting room, use the internal_id
          /* if ((isMeetingRoom || isMeetingRoomRoom) && item.extras) {
            const extras = item.extras;
            if (isMeetingRoomExtras(extras)) {
              documentId = extras.internal_id || '';
            }
          } */

          if (documentId) {
            acc.push({
              documentId,
              path: item.path.trim(),
              component: null,
              isMeetingRoom: isMeetingRoom || isMeetingRoomRoom,
            });
          }
        }

        // Recursively map submenus
        if (item.subMenu) {
          acc.push(...mapMenuToRoutes(item.subMenu));
        }

        return acc;
      }, []);
    };

    if (menu.length > 0) {
      const mappedRoutes = mapMenuToRoutes(menu);
      logger.debug('[MenuRoutes] Mapped routes:', { data: mappedRoutes });
      setRoutes(mappedRoutes);
    }
  }, [menu]);

  return routes;
};
